var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_272_23720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9929 83.9763C43.4524 99.4359 68.5173 99.4359 83.9768 83.9763C99.4363 68.5168 99.4363 43.452 83.9768 27.9924C68.5173 12.5329 43.4524 12.5329 27.9929 27.9924C12.5334 43.4519 12.5334 68.5168 27.9929 83.9763Z",
    fill: "#42B57E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1474 72.1004L57.1487 72.0994L63.8495 65.3661C64.3515 64.8616 64.3495 64.0457 63.845 63.5436C63.3406 63.0415 62.5248 63.0435 62.0227 63.5479L57.5239 68.0686L57.5239 40.7784C57.5239 40.0667 56.9469 39.4897 56.2352 39.4897C55.5235 39.4897 54.9466 40.0665 54.9466 40.7782L54.9466 68.0685L50.4477 63.5479C49.9458 63.0436 49.1299 63.0416 48.6254 63.5436C48.1208 64.0459 48.1191 64.8617 48.6209 65.3661L55.3218 72.0995L55.3231 72.1005C55.8268 72.6053 56.6453 72.6037 57.1474 72.1004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_272_23720",
    x: 12.3984,
    y: 12.3978,
    width: 87.1729,
    height: 87.1731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_272_23720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_272_23720",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDarrow);
export default __webpack_public_path__ + "static/media/green-darrow.5aefb0a42d354a8f220a868a3ff633dd.svg";
export { ForwardRef as ReactComponent };